import api from "../apiConfig";

export const ApiProducts = async () => {
  try {
    const resp = await api.get("/api/apikey/products");

    return resp;
  } catch (error) {
    console.log("APi키 목록 조회 에러", error);
    return error;
  }
};
